module.exports = __webpack_public_path__ + "static/pot-leaf-cc8bd1058b6b25682f517caf380cfb3d.svg";